import { render } from "./ArticleCourseComponent.vue?vue&type=template&id=3815b3ee&scoped=true"
import script from "./ArticleCourseComponent.vue?vue&type=script&lang=js"
export * from "./ArticleCourseComponent.vue?vue&type=script&lang=js"

import "./ArticleCourseComponent.vue?vue&type=style&index=0&id=3815b3ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3815b3ee"]])

export default __exports__